import { useState, useContext } from "react"
import Header from "../../../layouts/Header"
import BackIcon from "../../../components/BackIcon"
import { useNavigate } from "react-router-dom"
import { Box, Paper, TextField, Tooltip, IconButton, Grid, Typography, MenuItem } from "@mui/material"
import { createTheme, ThemeProvider } from "@mui/material/styles"
import CustomBackdrop from "../../../components/CustomBackdrop"
import { useMutation, api, showWarning } from "../../../api"
import { GlobalContext } from "../../../contexts/GlobalContext"
import getIconComponent from "../../utils/getIconComponent"

const theme = createTheme({
  palette: { primary: { main: "#196C87" }, secondary: { main: "#2E7D32" } },
})

const StyledRoot = {
  width: "100%",
  maxWidth: "1200px",
  margin: "0 auto",
  padding: "20px",
  backgroundColor: "#f5f7fa",
  borderRadius: "12px",
  boxShadow: "0 4px 20px rgba(0,0,0,0.1)",
}

const CrearColores = () => {
  const navigate = useNavigate()
  const { selectedMenuInfo } = useContext(GlobalContext)

  const [formData, setFormData] = useState({
    colcodigo: "",
    coldescri: "",
    colstatus: "A",
  })

  const {
    mutateAsync: SaveCreacionColor,
    isPending: isSavingCreacion,
    isError,
  } = useMutation({
    queryKey: ["isCreatingColor"],
    fn: async (data) => {
      const response = await api.post("/Colores/createColores", data)
      return response.data
    },
    showError: "modal",
    showSuccess: "toast",
    onSuccess: () => navigate(-1),
  })

  const handleInputChange = (field, value) => {
    let finalValue = typeof value === "string" ? value.toUpperCase() : value

    if (field === "colcodigo") finalValue = finalValue.slice(0, 3)
    else if (field === "coldescri") finalValue = finalValue.slice(0, 24)

    setFormData((prev) => ({ ...prev, [field]: finalValue }))
  }

  const handleSubmit = async (e) => {
    if (e) e.preventDefault()

    // Validaciones del frontend
    if (!formData.colcodigo.trim()) return showWarning("El Código del Color es obligatorio")
    if (!formData.coldescri.trim()) return showWarning("La Descripción del Color es obligatoria")

    await SaveCreacionColor(formData)
  }

  const guardarAction = selectedMenuInfo?.data?.barraAcciones?.find((action) => action?.acccaption === "GRABAR")

  const toolbarActions = guardarAction
    ? [
        {
          label: guardarAction.acccaption,
          key: guardarAction.acccaption,
          icon: getIconComponent(guardarAction.accnameicono, guardarAction.acctipoico),
        },
      ]
    : []

  return (
    <ThemeProvider theme={theme}>
      <Header />
      <div className="main main-app p-3 p-lg-4">
        <BackIcon />
        <Box sx={{ mb: 2 }}>
          {toolbarActions.map((action) => (
            <Tooltip title={action.label} key={action.key}>
              <IconButton
                onClick={handleSubmit}
                disabled={isSavingCreacion}
                sx={{ border: "1px solid", borderColor: "divider", borderRadius: 1 }}
              >
                {action.icon}
              </IconButton>
            </Tooltip>
          ))}
        </Box>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            margin: "0 30px 30px 30px",
            fontSize: "25px",
          }}
        >
          <b>Crear Nuevo Color</b>
        </div>

        <CustomBackdrop isLoading={isSavingCreacion} />

        <Box sx={StyledRoot}>
          <Paper
            elevation={3}
            sx={{ p: 4, borderRadius: 3, background: "white" }}
            component="form"
            onSubmit={handleSubmit}
          >
            <Typography variant="h6" color="primary" gutterBottom>
              Datos del Color
            </Typography>

            <Grid container spacing={3}>
              {/* CÓDIGO COLOR */}
              <Grid item xs={12} sm={3}>
                <TextField
                  InputLabelProps={{ shrink: true }}
                  fullWidth
                  label="Código Color *"
                  value={formData.colcodigo}
                  onChange={(e) => handleInputChange("colcodigo", e.target.value)}
                  error={isError && !formData.colcodigo}
                  inputProps={{ maxLength: 3 }}
                />
              </Grid>

              {/* DESCRIPCIÓN COLOR */}
              <Grid item xs={12} sm={6}>
                <TextField
                  InputLabelProps={{ shrink: true }}
                  fullWidth
                  label="Descripción *"
                  value={formData.coldescri}
                  onChange={(e) => handleInputChange("coldescri", e.target.value)}
                  error={isError && !formData.coldescri}
                  inputProps={{ maxLength: 24 }}
                />
              </Grid>

              {/* ESTADO */}
              <Grid item xs={12} sm={3}>
                <TextField
                  select
                  InputLabelProps={{ shrink: true }}
                  fullWidth
                  label="Estado"
                  value={formData.colstatus}
                  onChange={(e) => handleInputChange("colstatus", e.target.value)}
                >
                  <MenuItem value="A">ACTIVO</MenuItem>
                  <MenuItem value="I">INACTIVO</MenuItem>
                </TextField>
              </Grid>
            </Grid>
          </Paper>
        </Box>
      </div>
    </ThemeProvider>
  )
}

export default CrearColores
